import { render, staticRenderFns } from "./TasksBlock.vue?vue&type=template&id=49e3e0a1&scoped=true&lang=pug"
import script from "./TasksBlock.vue?vue&type=script&lang=ts"
export * from "./TasksBlock.vue?vue&type=script&lang=ts"
import style0 from "./TasksBlock.vue?vue&type=style&index=0&id=49e3e0a1&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e3e0a1",
  null
  
)

export default component.exports